import { Injectable } from '@angular/core';
import { HttpClient ,HttpHeaders} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../../services/data.service';
import { TaxesFeeSetup } from '../../../POS/models/taxes-fee-setup';
import { TipSetup } from '../../../POS/models/tip-setup';
import { TenderSetup } from '../../../POS/models/tender-setup';
import { CommonFunctionService, UserPOSData} from '../../../services/Common/common-function.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenderTipTaxService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient,private common:CommonFunctionService) { 
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  }
  GetTaxesFeeExemptionRuleDetail(data) {
    this.GetGeaderdetails();
    return this.http
      .get(environment.GetTaxesFeeExemptionRuleDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.TaxesFeeExemptionRuleId,{headers:this.headers})
      .pipe(map(response => response));
  }

  AddTaxesFeeExemptionRule(data)
  {
    return this.http.post(environment.AddTaxesFeeExemptionRuleUrl, data,{headers:this.headers});
  }

  UpdateTaxesFeeExemptionRule(data) {
    this.GetGeaderdetails();
    return this.http.put(
      environment.UpdateTaxesFeeExemptionRuleUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.TaxesFeeExemptionRuleId,data,{headers:this.headers} );
  }
  GetTaxesFeeList(data) {
    this.GetGeaderdetails();
    return this.http
      .get(environment.GetTaxesFeeListUrl + "?PosSubscriptionId=" + data,{headers:this.headers})
      .pipe(map(response => response));
  }

  GetTaxesFeeDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetTaxesFeeDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response));
  }
  AddTips(data)
  {   this.GetGeaderdetails();
    return this.http.post(environment.AddTipsUrl, data,{headers:this.headers});
  }
  UpdateTips(data) {
    this.GetGeaderdetails();
    // return this.service.put(
    //   environment.UpdateTipsUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.TipsId,data );
    return this.service.create(
      environment.UpdateTipsUrl,data );
  }

  GetTipsDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<TipSetup>(environment.GetTipsDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response));
  }
  GetTenderDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<TenderSetup>(environment.GetTenderDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response));
  }
  
  GetTenderDetailid(data) {
    this.GetGeaderdetails();
    return this.http.get<TenderSetup>(environment.GetTenderDetailidUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response));
  }
  UpdateTender(data) {
    this.GetGeaderdetails();
    // return this.service.put(
    //   environment.UpdateTenderUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.TenderId,data );
    return this.http.post(
      environment.UpdateTenderUrl ,data ,{headers:this.headers});
  }
  AddTender(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.AddTenderUrl, data ,{headers:this.headers});
  }


  AddTaxesFee(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.AddTaxesFeeUrl, data,{headers:this.headers});
  }

  UpdateTaxesFee(data) {
    this.GetGeaderdetails();
    // return this.service.put(
    //   environment.UpdateTaxesFeeUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.TaxesFeeId,data );
    return this.http.post(
      environment.UpdateTaxesFeeUrl,data ,{headers:this.headers});
  }


  

  GetDuplicateTaxFeeName(data) {
    this.GetGeaderdetails();
    return this.http.get<TenderSetup>(environment.GetDuplicateTaxFeeNameUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&TaxFeeName="+data.TaxFeeName,{headers:this.headers})
    .pipe(map(response => response));
  }
  FilteringTaxFeeDetails(PosSubscriptionId,Fromdate1,todate1,taxrate,taxfeename)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.FilteringTaxFeeDetails+"?PosSubscriptionId="+PosSubscriptionId+"&fromdate="+Fromdate1+"&todate="+todate1+"&TaxRate="+ 
      taxrate+"&TaxFeeName="+taxfeename,{headers:this.headers})
      .pipe(map(response => response));
  }

  GetGeaderdetails()
  {
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

  }

}
